import { useState } from "react"
import AllGroups from "./AllGroups"
import MyGroups from "./MyGroups"

export default function GroupsAsOrganizer(){
  const [myGroups, setMyGroups] = useState(false)
  return(<>
  <div className="flex justify-between my-4">
    <h1 className="text-stone-600 font-semibold text-xl py-2">{myGroups?'Mis grupos':'Todos los grupos'}</h1>
    <button className="action-btn" onClick={()=>{setMyGroups(!myGroups)}}>{myGroups?'Todos los grupos':'Mis grupos'}</button>
  </div>
    {myGroups?<MyGroups/>:<AllGroups/>}
  </>)
}